import { defineComponent as _defineComponent } from 'vue';
import { BAlert } from "bootstrap-vue";
import { onMounted, ref } from "vue";
import { GalaxyApi } from "@/api";
import {} from "@/api/workflows";
import { rethrowSimple } from "@/utils/simple-error";
import GridInvocation from "../Grid/GridInvocation.vue";
import LoadingSpan from "../LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'StoredWorkflowInvocations',
    props: {
        storedWorkflowId: null
    },
    setup(__props) {
        const props = __props;
        const loading = ref(true);
        const workflow = ref();
        onMounted(async () => {
            try {
                const { data, error } = await GalaxyApi().GET("/api/workflows/{workflow_id}", {
                    params: { path: { workflow_id: props.storedWorkflowId } },
                });
                if (error) {
                    rethrowSimple(error);
                }
                workflow.value = data;
            }
            finally {
                loading.value = false;
            }
        });
        return { __sfc: true, props, loading, workflow, BAlert, GridInvocation, LoadingSpan };
    }
});
